<template>
    <div class="row wrapper border-bottom white-bg page-heading">
        <div class="col-sm-4">
            <h2>Bebambi</h2>
            <ol class="breadcrumb">
                <li v-for="(crumb, index) in crumbs" v-bind:key="index" v-if="index < crumbs.length-1">
                    <router-link v-bind:to="crumb.href">{{crumb.title}}</router-link>
                </li>
                <li v-for="(crumb, index) in crumbs" v-bind:key="index" v-if="index === crumbs.length-1" class="active">
                    <strong>{{crumb.title}}</strong>
                </li>
            </ol>
        </div>
        <div class="col-sm-8">
            <!--<div class="title-action">-->
                <!--<a href="" class="btn btn-primary">This is action area</a>-->
            <!--</div>-->
        </div>
    </div>

</template>

<script>
    export default {
        name: "PageTitle",
        props: {
              title: String,
            crumbs: Array
        },
        methods: {
        }
    }
</script>

<style scoped>

</style>
